import { render, staticRenderFns } from "./OrdersListFilters.vue?vue&type=template&id=2f857d94&scoped=true&"
import script from "./OrdersListFilters.vue?vue&type=script&lang=js&"
export * from "./OrdersListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f857d94",
  null
  
)

export default component.exports